import RelatedProducts from "./relatedProducts";

export default RelatedProducts;